import routes from './routes';
import translations from './translations';

export function registerCoreModule(ctx) {
  ctx.registerTranslations(translations).then();
  ctx.registerRoutes(routes).then();
  return {};
}
